import { StoryblokState } from '../types/State'

export const state: StoryblokState = {
  previewToken: '',
  stories: {}
}
